var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Linkedin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.7295 2.32617C6.74139 2.32617 1.05597 8.01159 1.05597 14.9999C1.05597 21.9885 6.74139 27.6737 13.7295 27.6737C20.7178 27.6737 26.4035 21.9885 26.4035 14.9999C26.4033 8.01159 20.7176 2.32617 13.7295 2.32617ZM13.7295 26.4237C7.43055 26.4237 2.30597 21.2991 2.30597 14.9999C2.30597 8.70096 7.43055 3.57617 13.7295 3.57617C20.0285 3.57617 25.1535 8.70096 25.1535 14.9999C25.1533 21.2991 20.0285 26.4237 13.7295 26.4237Z",
    fill: "#357EFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.29242 12.3147H10.2253V19.9676H7.29242V12.3147Z",
    fill: "#357EFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.72968 11.0938C9.54947 11.0938 10.2141 10.4876 10.2141 9.73966C10.2141 8.99178 9.54947 8.3855 8.72968 8.3855C7.90988 8.3855 7.2453 8.99178 7.2453 9.73966C7.2453 10.4876 7.90988 11.0938 8.72968 11.0938Z",
    fill: "#357EFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.5976 12.1416C16.997 12.1416 16.488 12.251 16.0697 12.4695C15.6518 12.6883 15.2389 13.052 14.8303 13.5612V12.3145H12.0991V19.9674H15.032V16.2922C15.032 15.5956 15.1426 15.1131 15.3636 14.8439C15.5847 14.5749 15.8726 14.4404 16.2282 14.4404C16.5501 14.4404 16.7999 14.5401 16.9778 14.7395C17.1557 14.9389 17.2443 15.2787 17.2443 15.7593V19.9674H20.1918V15.1035C20.1918 14.0945 19.9622 13.3487 19.5032 12.8658C19.0449 12.3829 18.4093 12.1416 17.5976 12.1416Z",
    fill: "#357EFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.1b81ff3fb95182ef577a43f250280ad8.svg";
export { ForwardRef as ReactComponent };